import { Component } from '@angular/core';


interface Transaction {
  date: string;
  reference: string;
  description: string;
  amount: number;
  status: string;
}

@Component({
  selector: 'app-dashboard-table',
  standalone: false,
  templateUrl: './dashboard-table.component.html',
  styleUrl: './dashboard-table.component.scss'
})
export class DashboardTableComponent {
  transactions: Transaction[] = [
    { date: '2026-05-01', reference: 'TXN-001', description: 'Product Sale',      amount: 1250.00, status: 'Completed' },
    { date: '2026-05-03', reference: 'TXN-002', description: 'Service Fee',        amount:  340.50, status: 'Completed' },
    { date: '2026-05-05', reference: 'TXN-003', description: 'Subscription',       amount:   99.00, status: 'Pending'   },
    { date: '2026-05-07', reference: 'TXN-004', description: 'Refund',             amount:  -200.00, status: 'Completed' },
    { date: '2026-05-09', reference: 'TXN-005', description: 'Consulting Invoice', amount: 4800.00, status: 'Pending'   },
    { date: '2026-05-11', reference: 'TXN-006', description: 'Hardware Purchase',  amount: -1500.00, status: 'Failed'    },
    { date: '2026-05-13', reference: 'TXN-007', description: 'License Renewal',    amount:  450.00, status: 'Completed' },
  ];
}
